import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { ensurePermissions } from '@/hooks/usePermissions';
import { hasFeature } from '@/lib/utils/features';
import { bootstrapSession } from '@/lib/utils/session';
import { useSessionStore } from '@/store/sessionStore';

/**
 * Layout for `/certified-materials`. Its one job is the gate, in two halves:
 * the feature flags (`certified-materials-brand` / `-supplier`) say the
 * company bought the module and pick the view, `certified-materials:read` says
 * this user may look. Hiding the sidebar entry is not access control — a typed
 * URL lands here — so both are checked where the route resolves, off the same
 * caches the page's own hooks read.
 */
export const Route = createFileRoute('/(client)/certified-materials/(pages)')({
  beforeLoad: async () => {
    const user = useSessionStore.getState().user ?? (await bootstrapSession());
    if (
      !hasFeature(user, 'certified-materials-brand') &&
      !hasFeature(user, 'certified-materials-supplier')
    ) {
      throw redirect({ to: '/dashboard' });
    }
    const perms = await ensurePermissions();
    if (!perms['certified-materials'].canRead) {
      throw redirect({ to: '/dashboard' });
    }
  },
  component: () => <Outlet />,
});
